import toastr from "toastr";

export const openAdvisorView = async (scope: "distro" | "advisor", id: string) => {
    const tab = window.open("", "_blank");
    try {
        const body = scope === "distro" ? { distroAccountId: id } : { advisorId: id };
        const response = await fetch("/api/sso/advisorview", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            throw new Error("mint failed: " + response.status);
        }
        const res = await response.json();
        if (tab) {
            tab.location.href = res.url;
        } else {
            window.location.href = res.url;
        }
    } catch (e) {
        if (tab) tab.close();
        toastr.error("Could not open the advisor portal");
    }
};
